/** Shared US state/city catalog for cascading State → City dropdowns (Sensemaker + SP Web). */

import { US_STATE_DISPLAY_LABELS } from './audience-filter-display-labels'

export interface UsLocationOption {
  value: string
  label: string
}

/** Major cities per US state — static catalog (~3 cities per state). */
export const CITIES_BY_STATE: Record<string, { value: string; label: string }[]> = {
  AL: [
    { value: 'birmingham', label: 'Birmingham' },
    { value: 'montgomery', label: 'Montgomery' },
    { value: 'huntsville', label: 'Huntsville' },
  ],
  AK: [
    { value: 'anchorage', label: 'Anchorage' },
    { value: 'fairbanks', label: 'Fairbanks' },
    { value: 'juneau', label: 'Juneau' },
  ],
  AZ: [
    { value: 'phoenix', label: 'Phoenix' },
    { value: 'tucson', label: 'Tucson' },
    { value: 'mesa', label: 'Mesa' },
  ],
  AR: [
    { value: 'little_rock', label: 'Little Rock' },
    { value: 'fort_smith', label: 'Fort Smith' },
    { value: 'fayetteville', label: 'Fayetteville' },
  ],
  CA: [
    { value: 'la', label: 'Los Angeles' },
    { value: 'sf', label: 'San Francisco' },
    { value: 'sd', label: 'San Diego' },
  ],
  CO: [
    { value: 'denver', label: 'Denver' },
    { value: 'colorado_springs', label: 'Colorado Springs' },
    { value: 'aurora', label: 'Aurora' },
  ],
  CT: [
    { value: 'bridgeport', label: 'Bridgeport' },
    { value: 'new_haven', label: 'New Haven' },
    { value: 'hartford', label: 'Hartford' },
  ],
  DE: [
    { value: 'wilmington', label: 'Wilmington' },
    { value: 'dover', label: 'Dover' },
    { value: 'newark', label: 'Newark' },
  ],
  FL: [
    { value: 'miami', label: 'Miami' },
    { value: 'tampa', label: 'Tampa' },
    { value: 'orlando', label: 'Orlando' },
  ],
  GA: [
    { value: 'atlanta', label: 'Atlanta' },
    { value: 'augusta', label: 'Augusta' },
    { value: 'columbus', label: 'Columbus' },
  ],
  HI: [
    { value: 'honolulu', label: 'Honolulu' },
    { value: 'hilo', label: 'Hilo' },
    { value: 'kailua', label: 'Kailua' },
  ],
  ID: [
    { value: 'boise', label: 'Boise' },
    { value: 'meridian', label: 'Meridian' },
    { value: 'nampa', label: 'Nampa' },
  ],
  IL: [
    { value: 'chicago', label: 'Chicago' },
    { value: 'springfield', label: 'Springfield' },
    { value: 'aurora', label: 'Aurora' },
  ],
  IN: [
    { value: 'indianapolis', label: 'Indianapolis' },
    { value: 'fort_wayne', label: 'Fort Wayne' },
    { value: 'evansville', label: 'Evansville' },
  ],
  IA: [
    { value: 'des_moines', label: 'Des Moines' },
    { value: 'cedar_rapids', label: 'Cedar Rapids' },
    { value: 'davenport', label: 'Davenport' },
  ],
  KS: [
    { value: 'wichita', label: 'Wichita' },
    { value: 'overland_park', label: 'Overland Park' },
    { value: 'kansas_city', label: 'Kansas City' },
  ],
  KY: [
    { value: 'louisville', label: 'Louisville' },
    { value: 'lexington', label: 'Lexington' },
    { value: 'bowling_green', label: 'Bowling Green' },
  ],
  LA: [
    { value: 'new_orleans', label: 'New Orleans' },
    { value: 'baton_rouge', label: 'Baton Rouge' },
    { value: 'shreveport', label: 'Shreveport' },
  ],
  ME: [
    { value: 'portland', label: 'Portland' },
    { value: 'lewiston', label: 'Lewiston' },
    { value: 'bangor', label: 'Bangor' },
  ],
  MD: [
    { value: 'baltimore', label: 'Baltimore' },
    { value: 'frederick', label: 'Frederick' },
    { value: 'rockville', label: 'Rockville' },
  ],
  MA: [
    { value: 'boston', label: 'Boston' },
    { value: 'worcester', label: 'Worcester' },
    { value: 'springfield', label: 'Springfield' },
  ],
  MI: [
    { value: 'detroit', label: 'Detroit' },
    { value: 'grand_rapids', label: 'Grand Rapids' },
    { value: 'ann_arbor', label: 'Ann Arbor' },
  ],
  MN: [
    { value: 'minneapolis', label: 'Minneapolis' },
    { value: 'saint_paul', label: 'Saint Paul' },
    { value: 'rochester', label: 'Rochester' },
  ],
  MS: [
    { value: 'jackson', label: 'Jackson' },
    { value: 'gulfport', label: 'Gulfport' },
    { value: 'southaven', label: 'Southaven' },
  ],
  MO: [
    { value: 'kansas_city', label: 'Kansas City' },
    { value: 'saint_louis', label: 'Saint Louis' },
    { value: 'springfield', label: 'Springfield' },
  ],
  MT: [
    { value: 'billings', label: 'Billings' },
    { value: 'missoula', label: 'Missoula' },
    { value: 'great_falls', label: 'Great Falls' },
  ],
  NE: [
    { value: 'omaha', label: 'Omaha' },
    { value: 'lincoln', label: 'Lincoln' },
    { value: 'bellevue', label: 'Bellevue' },
  ],
  NV: [
    { value: 'las_vegas', label: 'Las Vegas' },
    { value: 'henderson', label: 'Henderson' },
    { value: 'reno', label: 'Reno' },
  ],
  NH: [
    { value: 'manchester', label: 'Manchester' },
    { value: 'nashua', label: 'Nashua' },
    { value: 'concord', label: 'Concord' },
  ],
  NJ: [
    { value: 'newark', label: 'Newark' },
    { value: 'jersey_city', label: 'Jersey City' },
    { value: 'paterson', label: 'Paterson' },
  ],
  NM: [
    { value: 'albuquerque', label: 'Albuquerque' },
    { value: 'las_cruces', label: 'Las Cruces' },
    { value: 'rio_rancho', label: 'Rio Rancho' },
  ],
  NY: [
    { value: 'nyc', label: 'New York City' },
    { value: 'buffalo', label: 'Buffalo' },
    { value: 'rochester', label: 'Rochester' },
  ],
  NC: [
    { value: 'charlotte', label: 'Charlotte' },
    { value: 'raleigh', label: 'Raleigh' },
    { value: 'greensboro', label: 'Greensboro' },
  ],
  ND: [
    { value: 'fargo', label: 'Fargo' },
    { value: 'bismarck', label: 'Bismarck' },
    { value: 'grand_forks', label: 'Grand Forks' },
  ],
  OH: [
    { value: 'columbus', label: 'Columbus' },
    { value: 'cleveland', label: 'Cleveland' },
    { value: 'cincinnati', label: 'Cincinnati' },
  ],
  OK: [
    { value: 'oklahoma_city', label: 'Oklahoma City' },
    { value: 'tulsa', label: 'Tulsa' },
    { value: 'norman', label: 'Norman' },
  ],
  OR: [
    { value: 'portland', label: 'Portland' },
    { value: 'salem', label: 'Salem' },
    { value: 'eugene', label: 'Eugene' },
  ],
  PA: [
    { value: 'philadelphia', label: 'Philadelphia' },
    { value: 'pittsburgh', label: 'Pittsburgh' },
    { value: 'allentown', label: 'Allentown' },
  ],
  RI: [
    { value: 'providence', label: 'Providence' },
    { value: 'warwick', label: 'Warwick' },
    { value: 'cranston', label: 'Cranston' },
  ],
  SC: [
    { value: 'charleston', label: 'Charleston' },
    { value: 'columbia', label: 'Columbia' },
    { value: 'greenville', label: 'Greenville' },
  ],
  SD: [
    { value: 'sioux_falls', label: 'Sioux Falls' },
    { value: 'rapid_city', label: 'Rapid City' },
    { value: 'aberdeen', label: 'Aberdeen' },
  ],
  TN: [
    { value: 'nashville', label: 'Nashville' },
    { value: 'memphis', label: 'Memphis' },
    { value: 'knoxville', label: 'Knoxville' },
  ],
  TX: [
    { value: 'houston', label: 'Houston' },
    { value: 'dallas', label: 'Dallas' },
    { value: 'austin', label: 'Austin' },
  ],
  UT: [
    { value: 'salt_lake_city', label: 'Salt Lake City' },
    { value: 'west_valley_city', label: 'West Valley City' },
    { value: 'provo', label: 'Provo' },
  ],
  VT: [
    { value: 'burlington', label: 'Burlington' },
    { value: 'south_burlington', label: 'South Burlington' },
    { value: 'rutland', label: 'Rutland' },
  ],
  VA: [
    { value: 'virginia_beach', label: 'Virginia Beach' },
    { value: 'norfolk', label: 'Norfolk' },
    { value: 'richmond', label: 'Richmond' },
  ],
  WA: [
    { value: 'seattle', label: 'Seattle' },
    { value: 'spokane', label: 'Spokane' },
    { value: 'tacoma', label: 'Tacoma' },
  ],
  WV: [
    { value: 'charleston', label: 'Charleston' },
    { value: 'huntington', label: 'Huntington' },
    { value: 'morgantown', label: 'Morgantown' },
  ],
  WI: [
    { value: 'milwaukee', label: 'Milwaukee' },
    { value: 'madison', label: 'Madison' },
    { value: 'green_bay', label: 'Green Bay' },
  ],
  WY: [
    { value: 'cheyenne', label: 'Cheyenne' },
    { value: 'casper', label: 'Casper' },
    { value: 'laramie', label: 'Laramie' },
  ],
  DC: [
    { value: 'washington', label: 'Washington' },
  ],
}

export const US_STATE_OPTIONS: UsLocationOption[] = Object.entries(US_STATE_DISPLAY_LABELS).map(
  ([value, label]) => ({ value, label }),
)

const STATE_CODE_BY_LABEL = new Map(
  US_STATE_OPTIONS.map((option) => [option.label.toLowerCase(), option.value]),
)

/** Normalize stored state (code or full name) to a two-letter code. */
export function resolveStateCode(state: string | undefined): string {
  const trimmed = state?.trim() ?? ''
  if (!trimmed) return ''
  const upper = trimmed.toUpperCase()
  if (US_STATE_OPTIONS.some((option) => option.value === upper)) {
    return upper
  }
  return STATE_CODE_BY_LABEL.get(trimmed.toLowerCase()) ?? upper
}

export function getCitiesForState(state: string | undefined): UsLocationOption[] {
  const code = resolveStateCode(state)
  if (!code) return []
  return CITIES_BY_STATE[code] ?? []
}
